export const reportingQueryKeys = {
  all: ['reporting'] as const,
  agentSalesLive: (startAt: string, endAt: string, limit?: number) =>
    [...reportingQueryKeys.all, 'sales-live', 'agent-sales', startAt, endAt, limit] as const,
  agentSalesLiveSummary: (startAt: string, endAt: string) =>
    [...reportingQueryKeys.all, 'sales-live', 'agent-sales', 'summary', startAt, endAt] as const,
  attachmentRates: (startAt: string, endAt: string) =>
    [...reportingQueryKeys.all, 'sales-live', 'attachment-rates', startAt, endAt] as const,
  leAgentMapping: (activeOn?: string, department?: string, subDepartment?: string, limit?: number) =>
    [...reportingQueryKeys.all, 'le-agent-mapping', activeOn, department, subDepartment, limit] as const,
  salesPerformanceTargetsAll: () => [...reportingQueryKeys.all, 'sales-performance-targets'] as const,
  salesPerformanceTargets: (cycleMonth?: string) =>
    [...reportingQueryKeys.salesPerformanceTargetsAll(), cycleMonth] as const,
  csDashboardCallDynamicsStats: (
    agentName: string | null | undefined,
    todayStartAt: string,
    todayEndAt: string,
    last7DaysStartAt: string,
    last7DaysEndAt: string,
    monthStartAt: string,
    monthEndAt: string,
    limit?: number,
  ) =>
    [
      ...reportingQueryKeys.all,
      'cs-dashboard-call-dynamics-stats',
      agentName,
      todayStartAt,
      todayEndAt,
      last7DaysStartAt,
      last7DaysEndAt,
      monthStartAt,
      monthEndAt,
      limit,
    ] as const,
  csDashboardCallDynamicsRows: (startAt: string, endAt: string, limit?: number) =>
    [...reportingQueryKeys.all, 'cs-dashboard-call-dynamics-rows', startAt, endAt, limit] as const,
  csDashboardStats: (featureIds: string[], startAt?: string, endAt?: string) =>
    [...reportingQueryKeys.all, 'cs-dashboard-stats', featureIds, startAt, endAt] as const,
  csAgentRoster: () => [...reportingQueryKeys.all, 'cs-agent-roster'] as const,
  xeroTrialBalanceSyncJob: (jobId: string) =>
    [...reportingQueryKeys.all, 'xero-trial-balance-sync', 'job', jobId] as const,
};
